var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencilSquareFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-pencil-square-filled 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.75 5.99919C12.148 5.99919 12.5 6.35119 12.5 6.74919C12.5 7.16319 12.164 7.49919 11.75 7.49919C10.245 7.49919 4 7.49919 4 7.49919V19.4992H21V10.7492C21 10.3352 21.336 9.99919 21.75 9.99919C22.164 9.99919 22.5 10.3352 22.5 10.7492V19.9992C22.5 20.6202 21.978 20.9992 21.5 20.9992H3.5C3.02 20.9992 2.5 20.6202 2.5 19.9992V6.99919C2.5 6.51819 2.88 5.99919 3.5 5.99919H11.75ZM9.739 12.5252C8.694 15.5282 8.501 15.9752 8.501 16.3652C8.501 16.8062 8.886 16.9912 9.128 16.9912C9.4 16.9912 10.236 16.6902 12.957 15.7422L9.739 12.5252ZM10.627 11.6362L13.847 14.8562L22.255 6.45619C22.418 6.29319 22.5 6.07919 22.5 5.86419C22.5 5.65119 22.418 5.43719 22.255 5.27319C21.675 4.69519 20.797 3.81619 20.216 3.23719C20.053 3.07419 19.839 2.99219 19.625 2.99219C19.412 2.99219 19.197 3.07419 19.033 3.23719L10.627 11.6362Z",
    fill: "#04193B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilSquareFilled);
export default __webpack_public_path__ + "static/media/icon-pencil-square-filled.d2550acb3739f6afdd9d0a8890943615.svg";
export { ForwardRef as ReactComponent };